export const getFileFromBase64 = function (nomFichier, typeFichier, contenuFichierBase64) {
  const contenuFichierBrut = atob(contenuFichierBase64)

  const buffer = new ArrayBuffer(contenuFichierBrut.length)
  const contenuFichierOctets = new Uint8Array(buffer)

  for (let n = 0; n < contenuFichierBrut.length; n++) {
    contenuFichierOctets[n] = contenuFichierBrut.charCodeAt(n)
  }

  const fichierBlob = new Blob([buffer], { type: typeFichier })
  return new File([fichierBlob], nomFichier, {type: typeFichier})
}
